import { ITlfActionShowModalWindow, TlfContextProps } from "./interface";

/**
 * Opens the requested modal window in TLF context state.
 *
 * @param state - Current TLF context state.
 * @param action - Show-modal action containing the target modal key.
 * @returns Updated state with the requested modal shown.
 */
export const tlf_showModalWindow = (
  state: TlfContextProps,
  action: ITlfActionShowModalWindow,
): TlfContextProps => ({
  ...state,
  showModalWindow: action.modalWindow,
});
